import { render, staticRenderFns } from "./TransferPendingTransaction.vue?vue&type=template&id=41d2486c"
import script from "./TransferPendingTransaction.vue?vue&type=script&lang=js"
export * from "./TransferPendingTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports